/**
 * 获取search参数
 */

import { useMemo } from 'react';
import { useLocation } from '@medlinker/fundamental';
import qs from 'qs';

export default () => {
  const { search } = useLocation();

  return useMemo(() => qs.parse(search.replace(/^\?/, '')), [search]);
};
